import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { supabase } from '../supabaseClient';
import { useOffice } from '../store/officeContext';
import { getSignedImageUrl } from '../constants/CommonFunctions';
import OfficeRail from './OfficeRail';
import OfficeTopBar from './OfficeTopBar';
import { tokens } from '../theme/tokens';
import { CasesProvider } from '../store/casesContext';

const OfficeLayout = () => {
  const { officeId } = useParams();
  const { office, setOffice } = useOffice();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const loadOffice = async () => {
      setIsLoading(true);
      try {
        if (!officeId) return;
        const { data: officeData, error } = await supabase
          .from('office').select('*').eq('id', officeId).maybeSingle();
        if (error) { console.error('Error cargando el despacho:', error); return; }
        if (officeData && active) {
          officeData.icon_url = await getSignedImageUrl(officeData.icon_url);
          setOffice(officeData);
        }
      } finally {
        if (active) setIsLoading(false);
      }
    };
    loadOffice();
    return () => { active = false; };
  }, [officeId, setOffice]);

  if (isLoading || !office) {
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: tokens.colors.bg }}>
        <CircularProgress sx={{ color: tokens.colors.indigo }} />
      </Box>
    );
  }

  return (
    <CasesProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: tokens.colors.bg }}>
        <OfficeRail />
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <OfficeTopBar />
          <Box component="main" sx={{ px: { xs: 2, md: 3.75 }, pt: 3, pb: 10, maxWidth: 1180, width: '100%', mx: 'auto' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </CasesProvider>
  );
};

export default OfficeLayout;